import * as React from "react";
import styles from "./AuthButton.module.css";

interface AuthButtonProps {
  variant?: "primary" | "secondary";
  loading?: boolean;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  onClick?: () => void;
  children?: React.ReactNode;
  className?: string;
}

export const AuthButton: React.FC<AuthButtonProps> = ({
  variant = "primary",
  loading = false,
  disabled = false,
  type = "button",
  onClick,
  children,
  className,
}) => (
  <button
    className={[styles.btn, styles[variant], className].filter(Boolean).join(" ")}
    type={type}
    disabled={disabled || loading}
    onClick={onClick}
  >
    {loading ? <i className={`fa-solid fa-spinner ${styles.spinner}`} /> : children}
  </button>
);
